export default class VendaExtraModel {
    id?: number = null;
    vendaId: number = null;
    observacaoDesconto: string;
    servicoEntregaId?: number = null;
}
